const Filter = ({ size = "24", ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...props}>
    <path d="M10 18h4v-2h-4zM3 6v2h18V6zm3 7h12v-2H6z" />
  </svg>
);

export default Filter;
